
/**
 * Auto-generated file. Do not edit manually.
 */
export const SPRITES = {
  "blimp": "blimp.png",
  "businessjet": "businessjet.png",
  "commercialjet": "commercialjet.png",
  "cargo": "cargo.png",
  "helicopter1": "helicopter1.png",
  "helicopter2": "helicopter2.png",
  "piston": "piston.png",
  "military": "military.png",
  "regionaljet": "regionaljet.png",
  "unknown": "unknown.png",
  "turboprop": "turboprop.png"
} as const;
export const SPRITE_URL_PREFIX = '/sprites/png/planes';

export enum SpriteKeys {
    blimp = 'blimp',
    businessjet = 'businessjet',
    commercialjet = 'commercialjet',
    cargo = 'cargo',
    helicopter1 = 'helicopter1',
    helicopter2 = 'helicopter2',
    piston = 'piston',
    military = 'military',
    regionaljet = 'regionaljet',
    unknown = 'unknown',
    turboprop = 'turboprop'
}

export enum SpriteOperationType {
  touchandgo = 'touchandgo',
  arrival = 'arrival',
  departure = 'departure',
  overflight = 'overflight'
}

